export const checkIfAdded = (wishlistType, wishlistId) => `/api/v1/member/wishlist/${wishlistType}/${wishlistId}/exists`;
export const addToWishlist = '/api/v1/member/wishlist';
